import { Link } from '@tanstack/react-router'
import { Button } from '@trellis/roots/button'
import { X } from 'lucide-react'
import { useState } from 'react'

export const TWO_FACTOR_BANNER_DISMISSED_KEY = 'trellis:two-factor-banner-dismissed'

function readDismissed(): boolean {
  try {
    return sessionStorage.getItem(TWO_FACTOR_BANNER_DISMISSED_KEY) === 'true'
  } catch {
    return false
  }
}

interface TwoFactorEnrollmentBannerProps {
  enforcementDate: string
}

export function TwoFactorEnrollmentBanner({
  enforcementDate,
}: TwoFactorEnrollmentBannerProps) {
  const [dismissed, setDismissed] = useState(readDismissed)

  if (dismissed) return null

  function handleDismiss() {
    try {
      sessionStorage.setItem(TWO_FACTOR_BANNER_DISMISSED_KEY, 'true')
    } catch {
      // sessionStorage may be unavailable (private browsing) — dismissal just won't persist
    }
    setDismissed(true)
  }

  return (
    <div className="bg-amber-50 text-amber-900">
      <div className="mx-auto flex max-w-screen-2xl items-center justify-between gap-4 px-4 py-2 text-sm">
        <p>
          Two-factor authentication will be required from{' '}
          <span className="font-medium">{enforcementDate}</span>.{' '}
          <Link to="/2fa-setup" className="underline underline-offset-4">
            Set it up now
          </Link>
          .
        </p>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="shrink-0 text-amber-900 hover:bg-amber-100 hover:text-amber-900"
          onClick={handleDismiss}
        >
          <X className="size-4" />
        </Button>
      </div>
    </div>
  )
}
